module.exports = __webpack_public_path__ + "static/media/25488341_1703518963056621_7499572418914431089_o.18ea0f16.jpg";